<template>
  <div class="account-page addresses">
    <AccountPanel title="Lista adresów dostaw">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">imię i nazwisko</th>
              <th scope="col">ulica</th>
              <th scope="col">kod pocztowy</th>
              <th scope="col">miasto</th>
              <th scope="col">e-mail</th>
              <th scope="col">telefon</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="address in user.addresses">
              <td>
                <span class="user-mobile-label">imię i nazwisko</span>
                <span>{{address.forname}} {{address.surname}}</span>
              </td>
              <td>
                <span class="user-mobile-label">ulica</span>
                <span>{{address.street}}</span>
              </td>
              <td>
                <span class="user-mobile-label">kod pocztowy</span>
                <span>{{address.postcode}}</span>
              </td>
              <td>
                <span class="user-mobile-label">miasto</span>
                <span>{{address.city}}</span>
              </td>
              <td>
                <span class="user-mobile-label">email</span>
                <span>{{address.email}}</span>
              </td>
              <td>
                <span class="user-mobile-label">telefon</span>
                <span>{{address.phone}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </AccountPanel>
  </div>
</template>

<script>
import { mapState } from "vuex";

import AccountPanel from "./AccountPanel.vue";

export default {
  components: { AccountPanel },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    this.$store.dispatch("user/getAddresses");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/Addresses.vue